import React from 'react';

const ScriptSelector = ({ scripts = [], selectedScript, onScriptSelect }) => {
  // Script descriptions for better user experience
  const scriptDescriptions = {
    'example.py': '一个简单的Python脚本，生成带时间戳的示例输出',
    'generate_crypto_json.sh': '一个shell脚本，生成JSON格式的加密参数',
    'example_with_args.sh': '一个带参数的shell脚本示例'
  };

  // Script types for display
  const scriptTypes = {
    'example.py': 'Python 脚本',
    'generate_crypto_json.sh': 'Shell 脚本',
    'example_with_args.sh': 'Shell 脚本'
  };

  return (
    <div className="script-selector form-group">
      <label htmlFor="scriptSelect">选择脚本:</label>
      <select 
        id="scriptSelect" 
        value={selectedScript} 
        onChange={(e) => onScriptSelect(e.target.value)}
        required
        className="script-select"
      >
        <option value="">-- 选择一个脚本 --</option>
        {scripts && scripts.length > 0 ? (
          scripts.map((script) => {
            // 兼容旧格式（只有脚本名）和新格式（包含参数提示）
            const scriptName = typeof script === 'string' ? script : script.name;
            return (
              <option key={scriptName} value={scriptName}>
                {scriptName}
              </option>
            );
          })
        ) : (
          <option value="" disabled>
            暂无可用脚本
          </option>
        )}
      </select>
      
      {/* 显示参数提示 */}
      {selectedScript && scripts && scripts.length > 0 && (
        <div className="param-hints">
          {(() => {
            const selected = scripts.find(script => 
              typeof script === 'string' ? script === selectedScript : script.name === selectedScript
            );
            
            if (selected && typeof selected !== 'string' && selected.param_hints && Object.keys(selected.param_hints).length > 0) {
              return (
                <div className="param-hints-content">
                  <h4>参数说明:</h4>
                  <ul>
                    {Object.entries(selected.param_hints).map(([paramName, paramInfo]) => (
                      <li key={paramName}>
                        <strong>{paramName}</strong> 
                        {paramInfo.type && ` (${paramInfo.type})`}:
                        {paramInfo.description && ` ${paramInfo.description}`}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            }
            
            return null;
          })()}
        </div>
      )}
      
      {selectedScript && (
        <div className="script-details card">
          <div className="script-info-header">
            <span className="script-type-badge">{scriptTypes[selectedScript] || '脚本'}</span>
          </div>
          <div className="script-info-content">
            <p className="script-description">{scriptDescriptions[selectedScript] || '暂无描述信息'}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScriptSelector;